export const EVENT_TYPE_EV_CONNECTED = 'EV_CONNECTED';
export const EVENT_TYPE_EV_DISCONNECTED = 'EV_DISCONNECTED';
export const EVENT_TYPE_START_DISCHARGING_SESSION = 'START_DISCHARGING_SESSION';
export const EVENT_TYPE_START_CHARGING_SESSION = 'START_CHARGING_SESSION';
export const EVENT_TYPE_END_CHARGING_SESSION = 'END_CHARGING_SESSION';
export const EVENT_TYPE_END_CHARGING_SESSION_WITH_ERROR = 'END_CHARGING_SESSION_WITH_ERROR';
export const EVENT_TYPE_OFFLINE = 'OFFLINE';
export const EVENT_TYPE_ONLINE = 'ONLINE';
export const EVENT_TYPE_FAULT = 'FAULT';
export const EVENT_TYPE_AUTHORIZATION_REQUEST = 'AUTHORIZATION_REQUEST';
export const EVENT_TYPE_CHARGER_STANDBY = 'CHARGER_STANDBY';
export const EVENT_TYPE_START_APPLYING_LIMIT = 'START_APPLYING_LIMIT';
export const EVENT_TYPE_FINISH_APPLYING_LIMIT = 'FINISH_APPLYING_LIMIT';
export const EVENT_TYPE_ONLINE_NO_SESSION = 'ONLINE_NO_SESSION';
export const EVENT_TYPE_OVER_PROTECTION_TRIGGER = 'OVER_PROTECTION_TRIGGER';
export const EVENT_TYPE_UNDER_CONSUMPTION_TRIGGER = 'UNDER_CONSUMPTION_TRIGGER';
export const EVENT_TYPE_FINISH_APPLYING_LIMIT_W_OWNER = 'FINISH_APPLYING_LIMIT_W_OWNER';
export const EVENT_TYPE_PLAZA_CREATED = 'PLAZA_CREATED';
export const EVENT_TYPE_NUMBER_OF_PHASES_CHANGED = 'NUMBER_OF_PHASES_CHANGED';
export const EVENT_TYPE_ROGUE_CHARGERS_DETECTED = 'ROGUE_CHARGERS_DETECTED';
//
export const EVENT_TYPE_LOCAL_OA_CONFIRMED = 'LOCAL_OA_CONFIRMED';
export const EVENT_TYPE_CURRENT_BASED_OA_CONFIRMED = 'CURRENT_BASED_OA_CONFIRMED';
export const EVENT_TYPE_POWER_BASED_OA_CONFIRMED = 'POWER_BASED_OA_CONFIRMED';
export const EVENT_TYPE_OVER_CONSUMPTION_TA_CONFIRMED = 'OVER_CONSUMPTION_TA_CONFIRMED';
export const EVENT_TYPE_UNDER_CONSUMPTION_TA_CONFIRMED = 'UNDER_CONSUMPTION_TA_CONFIRMED';
//
export const EVENT_TYPE_FINISH_PLAZA_NODE_POWER_LIMITS_UPDATE = 'FINISH_PLAZA_NODE_POWER_LIMITS_UPDATE';
export const EVENT_TYPE_FINISH_PLAZA_NODE_LOAD_LIMITS_UPDATE = 'FINISH_PLAZA_NODE_LOAD_LIMITS_UPDATE';
export const EVENT_TYPE_FINISH_PLAZA_NODE_HARD_CONSTRAINT_LIMITS_UPDATE = 'FINISH_PLAZA_NODE_HARD_CONSTRAINT_LIMITS_UPDATE';
export const EVENT_TYPE_FINISH_PLAZA_NODE_CHARGER_LIMITS_UPDATE = 'FINISH_PLAZA_NODE_CHARGER_LIMITS_UPDATE';
export const EVENT_TYPE_MEASUREMENT_POINT_UPDATE = 'MEASUREMENT_POINT_UPDATE';
export const EVENT_TYPE_FINISH_PLAZA_NODE_DYNAMIC_LIMITS_UPDATE = 'FINISH_PLAZA_NODE_DYNAMIC_LIMITS_UPDATE';

export const EVENT_PANEL_WIDTH = 288;

export const EVENT_LIST_LABELS = {
  [EVENT_TYPE_EV_CONNECTED]: 'Car is Plugged In',
  [EVENT_TYPE_EV_DISCONNECTED]: 'Car is Unplugged',
  [EVENT_TYPE_OFFLINE]: 'Charger Went Offline',
  [EVENT_TYPE_ONLINE]: 'Charger Returned Online',
  [EVENT_TYPE_START_CHARGING_SESSION]: 'Charging Session Started',
  [EVENT_TYPE_END_CHARGING_SESSION]: 'Charging Session Ended',
  [EVENT_TYPE_FINISH_APPLYING_LIMIT]: 'Limits Applied',
  [EVENT_TYPE_FAULT]: 'Fault Occurred',
  [EVENT_TYPE_CHARGER_STANDBY]: 'Limits Updated',
  [EVENT_TYPE_FINISH_APPLYING_LIMIT_W_OWNER]: 'Limits Updated by Telemetry Monitor',
  [EVENT_TYPE_OVER_PROTECTION_TRIGGER]: 'Over Protection Telemetry Monitor Triggered',
  [EVENT_TYPE_UNDER_CONSUMPTION_TRIGGER]: 'Under Utilization Telemetry Monitor Triggered',
  [EVENT_TYPE_START_DISCHARGING_SESSION]: 'Discharging Session Started',
  [EVENT_TYPE_END_CHARGING_SESSION_WITH_ERROR]: 'Session Ended With Error',
  [EVENT_TYPE_AUTHORIZATION_REQUEST]: 'Authorization Request Issued',
  [EVENT_TYPE_START_APPLYING_LIMIT]: 'Limits Requested',
  [EVENT_TYPE_ONLINE_NO_SESSION]: 'Online. No session',
  [EVENT_TYPE_PLAZA_CREATED]: 'Plaza created',
  [EVENT_TYPE_NUMBER_OF_PHASES_CHANGED]: 'Number of Phases Changed',
  [EVENT_TYPE_ROGUE_CHARGERS_DETECTED]: 'Rogue charger detected',
  //
  [EVENT_TYPE_LOCAL_OA_CONFIRMED]: 'Local Agent Limits Applied',
  [EVENT_TYPE_CURRENT_BASED_OA_CONFIRMED]: 'Current Based OA Limits Applied',
  [EVENT_TYPE_POWER_BASED_OA_CONFIRMED]: 'Power Based OA Limits Applied',
  [EVENT_TYPE_OVER_CONSUMPTION_TA_CONFIRMED]: 'Over TA Limits Applied',
  [EVENT_TYPE_UNDER_CONSUMPTION_TA_CONFIRMED]: 'Under TA Limits Applied',
  //
  [EVENT_TYPE_FINISH_PLAZA_NODE_POWER_LIMITS_UPDATE]: 'Power Soft Constraint Limits Updated',
  [EVENT_TYPE_FINISH_PLAZA_NODE_LOAD_LIMITS_UPDATE]: 'Load Soft Constraint Limits Updated',
  [EVENT_TYPE_FINISH_PLAZA_NODE_HARD_CONSTRAINT_LIMITS_UPDATE]: 'Hard Constraint Limits Updated',
  [EVENT_TYPE_FINISH_PLAZA_NODE_CHARGER_LIMITS_UPDATE]: 'Charger Node Limits Updated',
  [EVENT_TYPE_MEASUREMENT_POINT_UPDATE]: 'Measurement Point Node Value Updated',
  [EVENT_TYPE_FINISH_PLAZA_NODE_DYNAMIC_LIMITS_UPDATE]: 'Dynamic Soft Constraint Limits Updated',
};

export const EVENT_CLASS_NAMES = {
  [EVENT_TYPE_EV_CONNECTED]: 'dynamic-icon evConnected active preload',
  [EVENT_TYPE_EV_DISCONNECTED]: 'dynamic-icon evDisconnected active preload',
  [EVENT_TYPE_START_CHARGING_SESSION]: 'dynamic-icon applyingLimit active preload',
  [EVENT_TYPE_START_DISCHARGING_SESSION]: 'dynamic-icon discharging active preload',
  [EVENT_TYPE_END_CHARGING_SESSION]: 'dynamic-icon sessionFinished active preload',
  [EVENT_TYPE_END_CHARGING_SESSION_WITH_ERROR]: 'dynamic-icon sessionFinished active error preload',
  [EVENT_TYPE_OFFLINE]: 'dynamic-icon online active preload',
  [EVENT_TYPE_ONLINE]: null,
  [EVENT_TYPE_FAULT]: 'dynamic-icon chargingError active preload',
  [EVENT_TYPE_AUTHORIZATION_REQUEST]: 'dynamic-icon authorizationRequested active preload',
  [EVENT_TYPE_NUMBER_OF_PHASES_CHANGED]: 'dynamic-icon authorizationRequested active preload',
  [EVENT_TYPE_START_APPLYING_LIMIT]: 'dynamic-icon authorizationRequested active preload',
  [EVENT_TYPE_FINISH_APPLYING_LIMIT]: 'dynamic-icon applyingLimit active preload',
  [EVENT_TYPE_PLAZA_CREATED]: 'dynamic-icon online active preload',

  [EVENT_TYPE_LOCAL_OA_CONFIRMED]: 'dynamic-icon applyingLimit active preload',
  [EVENT_TYPE_CURRENT_BASED_OA_CONFIRMED]: 'dynamic-icon applyingLimit active preload',
  [EVENT_TYPE_POWER_BASED_OA_CONFIRMED]: 'dynamic-icon applyingLimit active preload',
  [EVENT_TYPE_OVER_CONSUMPTION_TA_CONFIRMED]: 'dynamic-icon applyingLimit active preload',
  [EVENT_TYPE_UNDER_CONSUMPTION_TA_CONFIRMED]: 'dynamic-icon applyingLimit active preload',
};

export const getEventClassName = (eventType, nodeProps, getCurrentStateClassName) => {
  const actualEventType = eventType === EVENT_TYPE_END_CHARGING_SESSION && nodeProps.chargingError
    ? EVENT_TYPE_END_CHARGING_SESSION_WITH_ERROR : eventType;

  if (
    actualEventType === EVENT_TYPE_FAULT
    && (
      (nodeProps.requestedDischargingLoad === null || nodeProps.requestedDischargingLoad !== undefined)
      && (nodeProps.requestedLoad === null || nodeProps.requestedLoad === undefined)
    )
  ) {
    return getCurrentStateClassName(nodeProps);
  }

  return EVENT_CLASS_NAMES[actualEventType];
};

export const makeChargerEventsState = (events, previousState) => {
  const updatedState = { ...previousState };

  events.forEach(
    (event) => {
      const { chargerUuid, plazaEventType } = event;

      if (!updatedState[chargerUuid]) {
        updatedState[chargerUuid] = [];
      }

      updatedState[chargerUuid].push(plazaEventType);
    },
  );

  return updatedState;
};

export const mapEventTypes = (item) => {
  if (item.value === EVENT_TYPE_FINISH_APPLYING_LIMIT_W_OWNER) {
    return { eventType: EVENT_TYPE_FINISH_APPLYING_LIMIT, owner: ['OVERLOAD_PROTECTION', 'UNDER_CONSUMPTION'] };
  }

  return { eventType: item.value };
};

export const defaultEventTypes = [
  { label: EVENT_LIST_LABELS[EVENT_TYPE_EV_CONNECTED], value: EVENT_TYPE_EV_CONNECTED },
  { label: EVENT_LIST_LABELS[EVENT_TYPE_EV_DISCONNECTED], value: EVENT_TYPE_EV_DISCONNECTED },
  { label: EVENT_LIST_LABELS[EVENT_TYPE_OFFLINE], value: EVENT_TYPE_OFFLINE },
  { label: EVENT_LIST_LABELS[EVENT_TYPE_ONLINE], value: EVENT_TYPE_ONLINE },
  { label: EVENT_LIST_LABELS[EVENT_TYPE_START_CHARGING_SESSION], value: EVENT_TYPE_START_CHARGING_SESSION },
  { label: EVENT_LIST_LABELS[EVENT_TYPE_END_CHARGING_SESSION], value: EVENT_TYPE_END_CHARGING_SESSION },
  { label: EVENT_LIST_LABELS[EVENT_TYPE_START_DISCHARGING_SESSION], value: EVENT_TYPE_START_DISCHARGING_SESSION },
  { label: EVENT_LIST_LABELS[EVENT_TYPE_AUTHORIZATION_REQUEST], value: EVENT_TYPE_AUTHORIZATION_REQUEST },
  { label: EVENT_LIST_LABELS[EVENT_TYPE_LOCAL_OA_CONFIRMED], value: EVENT_TYPE_LOCAL_OA_CONFIRMED },
  { label: EVENT_LIST_LABELS[EVENT_TYPE_CURRENT_BASED_OA_CONFIRMED], value: EVENT_TYPE_CURRENT_BASED_OA_CONFIRMED },
  { label: EVENT_LIST_LABELS[EVENT_TYPE_POWER_BASED_OA_CONFIRMED], value: EVENT_TYPE_POWER_BASED_OA_CONFIRMED },
  {
    label: EVENT_LIST_LABELS[EVENT_TYPE_FINISH_PLAZA_NODE_POWER_LIMITS_UPDATE],
    value: EVENT_TYPE_FINISH_PLAZA_NODE_POWER_LIMITS_UPDATE,
  },
  {
    label: EVENT_LIST_LABELS[EVENT_TYPE_FINISH_PLAZA_NODE_LOAD_LIMITS_UPDATE],
    value: EVENT_TYPE_FINISH_PLAZA_NODE_LOAD_LIMITS_UPDATE,
  },
  {
    label: EVENT_LIST_LABELS[EVENT_TYPE_FINISH_PLAZA_NODE_HARD_CONSTRAINT_LIMITS_UPDATE],
    value: EVENT_TYPE_FINISH_PLAZA_NODE_HARD_CONSTRAINT_LIMITS_UPDATE,
  },
  {
    label: EVENT_LIST_LABELS[EVENT_TYPE_FINISH_PLAZA_NODE_CHARGER_LIMITS_UPDATE],
    value: EVENT_TYPE_FINISH_PLAZA_NODE_CHARGER_LIMITS_UPDATE,
  },
  {
    label: EVENT_LIST_LABELS[EVENT_TYPE_FINISH_PLAZA_NODE_DYNAMIC_LIMITS_UPDATE],
    value: EVENT_TYPE_FINISH_PLAZA_NODE_DYNAMIC_LIMITS_UPDATE,
  },
  { label: EVENT_LIST_LABELS[EVENT_TYPE_MEASUREMENT_POINT_UPDATE], value: EVENT_TYPE_MEASUREMENT_POINT_UPDATE },
  { label: EVENT_LIST_LABELS[EVENT_TYPE_FAULT], value: EVENT_TYPE_FAULT },
  { label: EVENT_LIST_LABELS[EVENT_TYPE_NUMBER_OF_PHASES_CHANGED], value: EVENT_TYPE_NUMBER_OF_PHASES_CHANGED },
  { label: EVENT_LIST_LABELS[EVENT_TYPE_PLAZA_CREATED], value: EVENT_TYPE_PLAZA_CREATED },
];
